let RelevantTerms = () => {
  return (input) => {
  	return input.replace(/\s(da|de|do|dos|das)/ig, '');
  };
};

RelevantTerms.$inject = [];

export default RelevantTerms;



// WEBPACK FOOTER //
// ./client/app/common/filters/relevant-terms.filter.js